export default function useDevelopmentMode() {
  return {
    isAppInStandaloneMode: typeof window.__SHELL__ === "undefined",
    isAppInDevelopmentMode: window.CONFIG.environment === "dev"
  };
}
